import { render } from "./GallerySlider.vue?vue&type=template&id=49912dc9"
import script from "./GallerySlider.vue?vue&type=script&lang=js"
export * from "./GallerySlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__